import { Order } from '../../lib/types';
import { ReportType } from './ReportsFilterBar';
import { csvRow } from './csvEscape';

export function buildCsv(reportType: ReportType, orders: Order[], total: number): string {
  if (reportType === 'staff') {
    const lines = [csvRow(['Staff', 'Orders', 'Total Spend', 'Avg per Order'])];
    const grouped: Record<string, { count: number; spend: number }> = {};
    orders.forEach(o => {
      const name = o.staff_name || 'Unassigned';
      if (!grouped[name]) grouped[name] = { count: 0, spend: 0 };
      grouped[name].count++;
      grouped[name].spend += o.total_cost || 0;
    });
    Object.entries(grouped).sort((a, b) => b[1].spend - a[1].spend).forEach(([name, data]) => {
      lines.push(csvRow([name, data.count, data.spend.toFixed(2), (data.spend / data.count).toFixed(2)]));
    });
    return lines.join('\n') + '\n';
  }
  if (reportType === 'vendor') {
    const lines = [csvRow(['Vendor', 'Orders', 'Total Spend', '% of Total'])];
    const grouped: Record<string, { count: number; spend: number }> = {};
    orders.forEach(o => {
      const v = o.vendor || 'Unknown';
      if (!grouped[v]) grouped[v] = { count: 0, spend: 0 };
      grouped[v].count++;
      grouped[v].spend += o.total_cost || 0;
    });
    Object.entries(grouped).sort((a, b) => b[1].spend - a[1].spend).forEach(([vendor, data]) => {
      const pct = total > 0 ? Math.round((data.spend / total) * 100) : 0;
      lines.push(csvRow([vendor, data.count, data.spend.toFixed(2), `${pct}%`]));
    });
    return lines.join('\n') + '\n';
  }
  // Default: raw rows
  const lines = [csvRow(['Date', 'Staff', 'Department', 'Vendor', 'Ref #', 'Category', 'Status', 'Cost'])];
  orders.forEach(o => {
    lines.push(csvRow([
      o.order_date || '', o.staff_name || '', o.department_name || '',
      o.vendor || '', o.order_number || '', o.category || '',
      o.status || '', o.total_cost?.toFixed(2) || '0',
    ]));
  });
  return lines.join('\n') + '\n';
}
